/**
 * Добавляет в <html> класс .touch или .no-touch, в зависимости от типа устройства.
 *
 * @module isTouchFlag
 */
import { isTouch } from './helpers';

$(document.documentElement).addClass(isTouch() ? 'touch' : 'no-touch');
